import { useEffect, useRef, useState } from 'react'

import { setupSkeletonCountObserver } from '@/common/utils/calculateSkeletonCount'

export function NewsCardSkeleton() {
  const [skeletonCount, setSkeletonCount] = useState(5)
  const rowRef = useRef<HTMLDivElement>(null)
  const containerRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    return setupSkeletonCountObserver(containerRef, rowRef, setSkeletonCount, 5)
  }, [])

  return (
    <div ref={containerRef} className="w-full space-y-4 pr-2">
      {Array.from({ length: skeletonCount }, (_, index) => (
        <div
          key={index}
          className="flex gap-4 p-5 animate-pulse w-full border border-base-200 shadow-2xs rounded-xl"
          ref={rowRef}
        >
          <div className="space-y-4 flex-1">
            <div className="w-42 h-4 bg-base-200 rounded-lg" />
            <div className="w-96 h-4 bg-base-200 rounded-lg" />
            <div className="w-96 h-4 bg-base-200 rounded-lg" />

            <div className="mt-12 w-32 h-4 bg-base-200 rounded-lg" />
          </div>

          <div className="rounded-xl min-h-36 h-full bg-base-200 w-1/3" />
        </div>
      ))}
    </div>
  )
}
